export default "__VITE_ASSET__b75ba151__"